module.exports = __webpack_public_path__ + "img/button_close_dark.e7c44c4e.png";